import logo from './../assets/logo-black.png';
import React, { Component } from 'react';

export default class Header extends Component {
    
    render() {
        return (
            <header className="App-header">
            {this.props.children}
                <a href="/" className="Logo-Slogan">
                    <img src={logo} className="logo" alt="logo" />
                    <div className="Slogan">Discovering Gems</div>
                </a>
            </header>
            
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Header.js